<script context="module" lang="ts">
  import { getAppConfig } from '../../../../../common/config/app-config';
  import { CONSTANTS } from '../../../../../common/config/constants';
  import { getJoodMembershipType } from '../../../../../common/util';
  import { ProductTilePriceGroupVariantType } from '../product-tile-main';

  const userPrimeLevel = getJoodMembershipType();
  const { joodExpiredFlag } = getAppConfig();
  const { BASIC, VIP, SMART, BASICPRIME, VIPPRIME, SMARTPRIME } = CONSTANTS;
</script>

<script lang="ts">
  import { selectCorrectSmartPrice, selectCorrectSmartPromoBoolean } from '../../../../../common/joodUtils';
  import GiftCardForm from '../../../../product-details/components/DigitalGiftCardProduct/GiftCardForm.svelte';
  import ProductOccasions from '../../../../product-details/components/DigitalGiftCardProduct/ProductOccasions.svelte';
  import ProductTasheelPrice from '../../../../product-details/components/DigitalGiftCardProduct/ProductTasheelPrice.svelte';
  import JoodDayBannerNew from '../../../../product-listing-search/components/JoodDayBannerNew.svelte';
  import ProductTilePriceNew from './ProductTilePriceNew.svelte';

  export let product;
  export let pdpGiftCardPriceData = null;
  export let variant: ProductTilePriceGroupVariantType = 'plp-list';
  export let isMegasaleProduct = [];

  $: visible = getComponentVisibility(product, variant);
  $: isPDPVariantWithGiftCard = variant === 'pdp' && product?.isDigitalGiftCard;
  $: isTacticalBasicPromo = product?.tacticalBasicPromo;
  $: isTacticalVipPromo = product?.tacticalVipPromo;
  $: isTacticalSmartPromo = selectCorrectSmartPromoBoolean(
    product?.tacticalSmartFirstPromo,
    product?.tacticalSmartRepeatingPromo
  );
  $: smartPrimePrice = selectCorrectSmartPrice(product?.smartFirstPrimePrice, product?.smartRepeatingPrimePrice);

  function getComponentVisibility(data, variant) {
    const isPDPVariant = variant === 'pdp';
    if (!isPDPVariant) {
      return !!data;
    }
    //return data?.isComingSoon !== true;
    return true;
  }
</script>

{#if visible}
  <section class="product-tile-price-new-group variant-{variant}">
    {#if isPDPVariantWithGiftCard}
      <ProductTasheelPrice data={pdpGiftCardPriceData} />
      <ProductOccasions data={pdpGiftCardPriceData} />
      <GiftCardForm data={pdpGiftCardPriceData} />
    {:else if userPrimeLevel === BASICPRIME || joodExpiredFlag === BASIC}
      {#if joodExpiredFlag === BASIC || !product?.basicPrimePrice || product?.basicPrimePrice === 0}
        <ProductTilePriceNew {isMegasaleProduct} {variant} priceType="NOPRIME" algoliaProductHit={product} />
      {/if}
      {#if !isTacticalBasicPromo && joodExpiredFlag !== 'BASIC'}
        <ProductTilePriceNew
          {isMegasaleProduct}
          {variant}
          priceType={BASICPRIME}
          algoliaProductHit={product}
          backgoundOverride={BASICPRIME}
        />
      {/if}
      {#if !joodExpiredFlag}
        <JoodDayBannerNew {variant} bannerType={BASICPRIME} algoliaProductHit={product} />
      {/if}
    {:else if userPrimeLevel === VIPPRIME || joodExpiredFlag === VIP}
      {#if joodExpiredFlag === VIP || !product?.vipPrimePrice || product?.vipPrimePrice === 0}
        <ProductTilePriceNew {isMegasaleProduct} {variant} priceType="NOPRIME" algoliaProductHit={product} />
      {/if}
      {#if !isTacticalVipPromo && joodExpiredFlag !== 'VIP'}
        <ProductTilePriceNew
          {isMegasaleProduct}
          {variant}
          priceType={VIPPRIME}
          algoliaProductHit={product}
          backgoundOverride={VIPPRIME}
        />
      {/if}
      {#if !joodExpiredFlag}
        <JoodDayBannerNew {variant} bannerType={VIPPRIME} algoliaProductHit={product} />
      {/if}
    {:else if userPrimeLevel === SMARTPRIME || joodExpiredFlag === SMART}
      {#if joodExpiredFlag === SMART || !smartPrimePrice || smartPrimePrice === 0}
        <ProductTilePriceNew
          {smartPrimePrice}
          {isMegasaleProduct}
          {variant}
          priceType="NOPRIME"
          algoliaProductHit={product}
        />
      {/if}
      {#if !isTacticalSmartPromo && !joodExpiredFlag}
        <ProductTilePriceNew
          {isMegasaleProduct}
          {variant}
          {smartPrimePrice}
          priceType={SMARTPRIME}
          algoliaProductHit={product}
          backgoundOverride={SMARTPRIME}
        />
      {/if}
      {#if !joodExpiredFlag}
        <JoodDayBannerNew {variant} bannerType={SMARTPRIME} algoliaProductHit={product} />
      {/if}
    {:else}
      <ProductTilePriceNew {isMegasaleProduct} {variant} priceType="NOPRIME" algoliaProductHit={product} />
    {/if}
  </section>
{/if}

<style lang="scss">
  @import '../../../../common/styles/colors.new.scss';
  .product-tile-price-new-group {
    &.variant- {
      &product-tile {
        display: flex;
        flex-direction: column;
        gap: 6px;
      }
      &plp-list,
      &pdp {
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
      }
      &.plp-list {
        @include responsive {
          gap: 4px;
        }
      }
    }
  }
</style>
